export function Information({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.95938 2.04062C9.54271 1.54896 10.4844 1.54896 11.051 2.04062L12.3677 3.16562C12.6177 3.37396 13.0927 3.54896 13.426 3.54896H14.8427C15.726 3.54896 16.451 4.27396 16.451 5.15729V6.57396C16.451 6.90729 16.626 7.37396 16.8344 7.62396L17.9594 8.94062C18.451 9.52396 18.451 10.4656 17.9594 11.0323L16.8344 12.349C16.626 12.599 16.451 13.0656 16.451 13.399V14.8156C16.451 15.699 15.726 16.424 14.8427 16.424H13.426C13.0927 16.424 12.626 16.599 12.376 16.8073L11.0594 17.9323C10.476 18.424 9.53438 18.424 8.96771 17.9323L7.65104 16.8073C7.40104 16.599 6.92604 16.424 6.60104 16.424H5.14271C4.25938 16.424 3.53437 15.699 3.53437 14.8156V13.3906C3.53437 13.0656 3.36771 12.5906 3.15937 12.349L2.03438 11.024C1.55104 10.449 1.55104 9.51562 2.03438 8.94062L3.15937 7.61563C3.36771 7.36562 3.53437 6.89896 3.53437 6.57396V5.16562C3.53437 4.28229 4.25938 3.55729 5.14271 3.55729H6.58438C6.91771 3.55729 7.38438 3.38229 7.63438 3.17396L8.95938 2.04062Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6.77344V10.7984"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99609 13.332H10.0036"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
